import { useIsClient } from '@fiverr-private/hooks';

interface Props {
    inLynxesGoogleOneTapFedCmRollout: boolean;
}

export const useIsFedCMAvailable = ({ inLynxesGoogleOneTapFedCmRollout }: Props) => {
    const isClient = useIsClient();
    const isFedCMAvailable = typeof window !== 'undefined' && 'IdentityCredential' in window;

    return isClient && isFedCMAvailable && inLynxesGoogleOneTapFedCmRollout;
};
